import { FileItemProps } from '@components/Core/Folders/FileItem/FileItem.component';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { InputBase } from '@mui/material';
import { Icons } from '@Assets/SvgIcons';
import { IconButton } from '@mui/material';
import './NewFolderModal.scss';

export type NewFolderModalProps = {
  open: boolean;
  handleClose: () => void;
  file?: FileItemProps;
  handleSubmit: (file: FileItemProps) => void;
};

const NewFolderModal = ({
  open,
  file,
  handleClose,
  handleSubmit,
}: NewFolderModalProps) => {
  const [name, setName] = useState<string>((file && file.name) || '');
  console.log('file', file);

  const { t } = useTranslation();
  const [description, setDescription] = useState<string>(
    (file && file.description) || ''
  );
  const [hasNameError, setHasNameError] = useState<boolean>(false);

  useEffect(() => {
    setHasNameError(false);
    setName((file && file.name) || '');
    setDescription((file && file.description) || '');
  }, [file]);

  const isValidFolderName = (name: string): boolean => {
    return /^[^\\/?%*:|"<>]+$/i.test(name);
  };

  const onSubmitClicked = () => {
    if (!isValidFolderName(name)) {
      setHasNameError(true);
      return;
    }

    if (file) {
      handleSubmit({
        ...file,
        name,
        description,
        htmlName: name,
        updatedAt: new Date().toDateString(),
      } as FileItemProps);
    } else {
      handleSubmit({
        id: uuidv4(),
        name,
        description,
        htmlName: name,
        type: 'folder',
        createdAt: new Date().toDateString(),
        files: [] as FileItemProps[],
      } as FileItemProps);
    }

    clearForm();
  };

  const clearForm = () => {
    setName('');
    setDescription('');
    setHasNameError(false);
  };

  const onCloseClicked = () => {
    clearForm();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onCloseClicked}
      classes={{ root: 'new-folder-dialog' }}
      id="new_folder_dialog"
    >
      <DialogTitle classes={{ root: 'new-folder-dialog__title' }}>
        {file ? (
          file.type && file.type === 'folder' ? (
            <Icons.FolderThin />
          ) : (
            <Icons.File />
          )
        ) : (
          <Icons.FolderThin />
        )}

        {file
          ? file.type && file.type === 'folder'
            ? 'Update Folder'
            : 'Update File'
          : 'Create New Folder'}
        <IconButton
          aria-label="close"
          className=""
          size="small"
          onClick={onCloseClicked}
        >
          <Icons.Cancel width="20" height="20" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div className="dialog-form-input">
          <div className="dialog-form-input__label">
            {t('folders.folder_name')}
          </div>
          <div className="">
            <InputBase
              style={{ width: '100%' }}
              fullWidth
              value={name}
              name="folder_name"
              placeholder={t('folders.folder_name')}
              error={hasNameError}
              onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                setName(target.value)
              }
            />
            {hasNameError && (
              <span className="input-error">
                {t('folders.folder_name_is_not_valid')}
              </span>
            )}
          </div>
        </div>
        <div className="dialog-form-input">
          <div className="dialog-form-input__label">
            {t('commons.description')}
          </div>
          <div className="">
            <InputBase
              style={{ width: '100%' }}
              fullWidth
              value={description}
              name="folder_desc"
              placeholder={t('commons.description')}
              onChange={({ target }: React.ChangeEvent<HTMLInputElement>) =>
                setDescription(target.value)
              }
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions classes={{ root: 'new-folder-dialog__actions' }}>
        <Button
          onClick={onCloseClicked}
          color="error"
          classes={{ root: 'new-folder-dialog__button thin' }}
        >
          {t('commons.cancel')}
        </Button>
        <Button
          onClick={onSubmitClicked}
          classes={{ root: 'new-folder-dialog__button' }}
        >
          {t('commons.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewFolderModal;
